import { getClosestShops } from '../../../utils';

export const updateShops = async component => {
  const { customerAddress, updateClosestShops } = component.props;
  const shops = await getClosestShops(customerAddress, customerAddress.orderType);
  await updateClosestShops(shops);
};
